import { useMemo } from 'react';
import {
  GridColDef,
  GridSlotsComponentsProps,
} from '@mui/x-data-grid-pro';
import { ContractOnView } from 'shared/domain/contract/types/view';

interface UseContractDataGridSlotPropsOptions {
  columns: GridColDef<ContractOnView>[];
}

export function useContractDataGridSlotProps({
  columns,
}: UseContractDataGridSlotPropsOptions): GridSlotsComponentsProps {
  return useMemo(
    () => ({
      columnsManagement: {
        disableShowHideToggle: false,
        disableResetButton: true,
        getTogglableColumns: () => columns.map((column) => column.field),
      },
      loadingOverlay: {
        variant: 'skeleton',
        noRowsVariant: 'skeleton',
      },
      basePopper: {
        placement: 'bottom-end',
      },
      baseTextField: { variant: 'outlined', size: 'small' },
      baseSelect: { variant: 'outlined', size: 'small' },
    }),
    [columns]
  );
}
